import React from 'react'

const TabCloseDelivery = () => {
  return (
    <>
      <div className="flex flex-col">
        <div className="px-4">
          <h1 className="text-bold text-4xl">Tutup pesanan</h1>
        </div>
        <div className="px-4 mb-16 mt-4">
          <p>
            Atur pesanan untuk memulai rekapan.
          </p>
        </div>
        <div className="px-4 mb-8 mt-4">
          <p className="text-lg font-bold">Maksimum transaksi</p>
            <input className="p-2 border rounded w-2/4" type="time" name="" id=""/>
        </div>
        <div className="px-4">
        <buttton className="bg-green-100 text-white font-bold py-4 px-8 rounded mt-2">Simpan</buttton>
        </div>
      </div>
    </>
  )
}

export default TabCloseDelivery